module.exports = "/_next/static/videos/video-s-8a567bd44173dac4a911eb3483563e07.mp4";